import Repository from "../Repository";

const resource = "/presets";
export default {
    get(params = null, url = null) {
        if (params) {
            // eslint-disable-next-line no-undef
            params.user = sso.getSsoUser();
            if (url !== '' && url) {
                return Repository.get(url, {params: params});
            } else {
                return Repository.get(`${resource}`, {params: params});
            }
        } else {
            // eslint-disable-next-line no-undef
            return Repository.get(`${resource}`, {params: {user: sso.getSsoUser()}});
        }
    },
    getPreset(id) {
        return Repository.get(`${resource}/${id}`);
    },
    getPresetDetails(id, dates, preset_columns) {
        return Repository.get(`${resource}/${id}/details`, {params: {dates: dates, presetColumns: preset_columns}});
    },
    getPresetKpis(id, dates, preset_columns) {
        return Repository.get(`${resource}/${id}/kpis`, {params: {dates: dates, presetColumns: preset_columns}});
    },
    getCompletionRate(id, json) {
        return Repository.post(`${resource}/${id}/completionrate`, json);
    },
    createPreset(json) {
        return Repository.post(`${resource}`, json);
    },
    copyPreset(id, user_id) {
        return Repository.post(`${resource}/${id}/copy`, user_id);
    },
    updatePreset(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    },
    updatePresetLink(id, json) {
        return Repository.put(`${resource}/${id}/link`, json);
    },
    deletePreset(id) {
        return Repository.delete(`${resource}/${id}`);
    },
    updatePresetDetails(id, json) {
        return Repository.put(`${resource}/${id}/details`, json);
    }
}